export default __webpack_public_path__ + "static/home-dumpster-067a6ad0f19973e58174bb3df09a4c7c.jpg";